import {focusElement} from '@wix/panda-js-utils'

export const focusFirstNewEvent = ({
  eventsCount,
  hasMore,
  pageLimit,
  compId,
  delay,
  listItem = true,
}: {
  eventsCount: number
  hasMore: boolean
  pageLimit: number
  compId: string
  delay?: number
  listItem?: boolean
}) => {
  if (eventsCount > pageLimit) {
    const index = hasMore ? eventsCount - pageLimit + 1 : eventsCount - (eventsCount % pageLimit) + 1
    const selector = `#${compId} ${listItem ? 'li' : 'div'}:nth-of-type(${index}) a`

    if (delay) {
      setTimeout(() => focusElement({selector, canFocus: true}), delay)
    } else {
      focusElement({selector, canFocus: true})
    }
  }
}
